import React from 'react';
import {
  EInterviewAtmosphere,
  EInterviewDificultyLevel,
  EInterviewProgress,
  EInterviewFinalResult,
} from 'enums/community.enum';
import styled from 'styled-components';
import { PrimaryColor, SecondaryColor } from 'GlobalStyles';
import frown from 'assets/icons/frown.svg';
import meh from 'assets/icons/meh.svg';
import smile from 'assets/icons/smile.svg';

type TType = {
  type: string;
};

const Tags = ({ type }: any) => {
  return (
    <QuestionTag type={type}>
      {(type === EInterviewAtmosphere.Uncomfortable || type === EInterviewDificultyLevel.Difficulty) && (
        <>
          <img src={frown} alt='icon' />
          {type === EInterviewAtmosphere.Uncomfortable && '경직'}
          {type === EInterviewDificultyLevel.Difficulty && '어려움'}
        </>
      )}
      {type === 'normal' && (
        <>
          <img src={meh} alt='icon' />
          보통
        </>
      )}
      {(type === EInterviewAtmosphere.Comfortable || type === EInterviewDificultyLevel.Easy) && (
        <>
          <img src={smile} alt='icon' />
          {type === EInterviewAtmosphere.Comfortable && '편안'}
          {type === EInterviewDificultyLevel.Easy && '쉬움'}
        </>
      )}

      {type === EInterviewFinalResult.Pass && '합격'}
      {type === EInterviewFinalResult.Proceeding && '진행중'}
      {type === EInterviewFinalResult.Fail && '불합격'}
      {type === EInterviewProgress.FaceToFace && '대면'}
      {type === EInterviewProgress.Zoom && 'Zoom'}
      {type === EInterviewProgress.Call && '전화'}
    </QuestionTag>
  );
};

export default Tags;

const QuestionTag = styled.div<TType>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 85px;
  padding: 5px;
  border: 1px solid;
  border-color: ${({ type }) =>
    (type === EInterviewAtmosphere.Uncomfortable ||
      type === EInterviewFinalResult.Fail ||
      type === EInterviewDificultyLevel.Difficulty) &&
    '#cd5959'};
  border-color: ${({ type }) =>
    (type === 'normal' ||
      type === EInterviewProgress.FaceToFace ||
      type === EInterviewProgress.Zoom ||
      type === EInterviewProgress.Call ||
      type === EInterviewFinalResult.Proceeding) &&
    `${PrimaryColor}`};
  border-color: ${({ type }) =>
    (type === EInterviewDificultyLevel.Easy ||
      type === EInterviewAtmosphere.Comfortable ||
      type === EInterviewFinalResult.Pass) &&
    `${SecondaryColor}`};
  border-radius: 20px;
  font-size: 16px;
  color: ${({ type }) =>
    (type === EInterviewAtmosphere.Uncomfortable ||
      type === EInterviewFinalResult.Fail ||
      type === EInterviewDificultyLevel.Difficulty) &&
    '#cd5959'};
  color: ${({ type }) =>
    (type === 'normal' ||
      type === EInterviewProgress.FaceToFace ||
      type === EInterviewProgress.Zoom ||
      type === EInterviewProgress.Call ||
      type === EInterviewFinalResult.Proceeding) &&
    `${PrimaryColor}`};
  color: ${({ type }) =>
    (type === EInterviewDificultyLevel.Easy ||
      type === EInterviewAtmosphere.Comfortable ||
      type === EInterviewFinalResult.Pass) &&
    `${SecondaryColor}`};
  text-align: center;

  img {
    margin-right: 5px;
  }
`;
